module.exports = __webpack_public_path__ + "img/05-主要功能.d730d2fd.png";